import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminDatamatrixRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/datamatrix',
}).lazy(() =>
  import(
    'pages/admin/DatamatrixGenerator/AdminDatamatrixGeneratorPage/AdminDatamatrixGeneratorPage'
  ).then((d) => d.Route)
);
